
<style>
    .collapse-a:before {
        font-family: "Font Awesome 5 Free";
        content: "\f067";
        margin-left: 10px
    }

    .collapse-a .collapse-a-title:before {
        content: "جزئیات بیشتر";
    }

    .collapse-a.lessDetails:before {
        font-family: "Font Awesome 5 Free";
        content: "\f068";
        margin-left: 10px
    }

    .collapse-a.lessDetails .collapse-a-title:before {
        content: "جزئیات کمتر";
    }

    .v-select ul li {
        padding: 10px 5px !important
    }
</style>
<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    ثبت یادداشت
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">
                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : taskNoteModel.createDateTime!==null}">زمان ثبت</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="taskNoteModel.createDateTime"
                                   id="endDT" />
                        </div>

                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : taskNoteModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="taskNoteModel.title" @input="v$.taskNoteModel.title.$touch()" :class="{invalid:v$.taskNoteModel.title.$error}">
                        <p class="text-danger" v-if="v$.taskNoteModel.title.required.$invalid && v$.taskNoteModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>


                    <div class="mb-3">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.taskNoteTypeId" label="title" placeholder="نوع یادداشت" :options="TaskNoteTypeList" :reduce="p => p.taskNoteTypeId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <!--@option:cleared="ChangeWorkGroup"-->
                        <v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="taskNoteModel.workGroupId" @option:selected="onChangeWorkGroup">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>

                    <div class="mb-3" id="drpUserId" style="display:none">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.userId" label="title" placeholder="یادداشت برای" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <p class="text-danger" v-if="v$.taskNoteModel.userId.required.$invalid && v$.taskNoteModel.userId.$dirty">لطفا یادداشت برای را انتخاب کنید.</p>
                    </div>

                    <div class="card mx-0 mb-2">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars show" id="collapse-description">
                            <textarea v-model="taskNoteModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
                        </div>
                    </div>
                    <button class="btn btn-link speechToTextBtn mb-2" @pointerdown="startR"
                            @pointerup="stopR">
                        <span :class="btnRecord">
                            <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                        </span>
                        <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                    </button>
                    <att-list v-bind:destination="'TaskNote'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="true" :canDelete="true" :oldAttList="[]" :hasLocation="true"></att-list>


                    <div class="collapse pt-3" id="collapse-moreDetails">
                        <div class="mb-3">
                            <v-select dir="rtl" label="title" placeholder="منشن" multiple chips :options="LocalUserListForMention" :reduce="p => p.userId" v-model="taskNoteModel.mentionUserIdsList">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                {{ option.fullTitle }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>




                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="taskNoteModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>

                    </div>

                    <button data-toggle="collapse" data-target="#collapse-moreDetails" class="btn btn-xxs mb-3 btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
                        <span class="collapse-a-title"></span>
                    </button>


                    <button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateTaskNote">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <date-picker type="datetime" v-model="taskNoteModel.createDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="endDT" :jumpMinute="5" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core';
    import HelpMenu from '../Components/HelpMenu.vue';
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';

    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';
    import { func } from '../../main';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            DatePicker,
            "Help-Menu": HelpMenu,
            "att-list": AttList
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                attInProgress: false,
                modified: false,
                showType: false,

                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                taskNoteModel: {
                    title: null,
                    noteId: 0,
                    leadId: null,
                    taskNoteTypeId: null,
                    userId: null,
                    noticeTemplate: false,
                    description: " ",
                    createDateTime: null,
                    attList: [],
                    mentionUserIdsList: [],


                    workGroupId: null,
                    projectId: null,
                    invoiceId: null,
                    preInvoiceId: null,
                    contractId: null,
                    letterId: null,
                    personId: null,
                    meetingId: null,
                    preBuyInvoiceId: null,
                    buyId: null,

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                }
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            propsToWatch() {
                return `${this.taskNoteModel.title}|${this.taskNoteModel.description}`;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
            TaskNoteTypeList() {
                return this.$store.getters.GetTaskNoteTypeList;
            },


            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            LocalUserListForMention() {
                return this.$store.getters.GetLocalUserListForMention;
            },
            WorkGroupList() {
                return this.$store.getters.GetWorkGroupList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        watch: {
            propsToWatch: {
                handler: function () {
                    console.log(this.modified);
                    this.modified = true;
                },
                deep: true
            },
            'taskNoteModel.workGroupId'(value) {
                this.onChangeWorkGroup();
            },
            'taskNoteModel.personId'(value) {
                this.onchangePerson();
            },
            'taskNoteModel.projectId'(value) {
                this.onchangeProject();
            },
            'taskNoteModel.preInvoiceId'(value) {
                this.onchangePreInvoice();
            },
            'taskNoteModel.contractId'(value) {
                this.onchangeContract();
            },
            'taskNoteModel.meetingId'(value) {
                this.onchangeMeeting();
            },
            'taskNoteModel.invoiceId'(value) {
                this.onchangeInvoice();
            },
            'taskNoteModel.letterId'(value) {
                this.onchangeLetter();
            },
            'taskNoteModel.buyId'(value) {
                this.onchangeBuy();
            },
            localUserListList: {
                //handler: function () {
                //}
            }
        },
        created() {
            this.getServerDateTime();
            this.getUserList();

            this.$store.dispatch("GetPersonListFromServer", {});
            this.$store.dispatch("GetProjectListFromServer", {});
            this.$store.dispatch("GetLocalUserListForMention", {});
            this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
            this.$store.dispatch("GetContractAbstractForPerson", {});
            this.$store.dispatch("GetInvoiceAbstractForPerson", {});
            this.$store.dispatch("GetLetterAbstractForPerson", {});
            this.$store.dispatch("GetMeetingAbstractForPerson", {});
            this.$store.dispatch("GetBuyAbstractForPerson", {});
			this.$store.dispatch("GetWorkGroupListFromServer", {});

            this.$store.dispatch("GetTaskNoteTypeListFromServer");
            this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                .then(data => {
                    if (data.data.expired)
                        document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "none");

                });
        },


        methods: {
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.taskNoteModel.projectId = null;
                this.taskNoteModel.invoiceId = null;
                this.taskNoteModel.preInvoiceId = null;
                this.taskNoteModel.contractId = null;
                this.taskNoteModel.letterId = null;
                this.taskNoteModel.meetingId = null;
                this.taskNoteModel.preBuyInvoiceId = null;
                this.taskNoteModel.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.taskNoteModel.contractId = null;
                this.taskNoteModel.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.taskNoteModel.personId,
                    projectId: this.taskNoteModel.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                    projectId: this.taskNoteModel.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                        projectId: this.taskNoteModel.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.taskNoteModel.contractId = null;
                this.taskNoteModel.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.taskNoteModel.preInvoiceId,
                    contractId: this.taskNoteModel.contractId,
                    personId: this.taskNoteModel.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.taskNoteModel.invoiceId = null;
                this.taskNoteModel.buyId = null;
                this.taskNoteModel.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.taskNoteModel.preInvoiceId,
                    contractId: this.taskNoteModel.contractId,
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                    projectId: this.taskNoteModel.projectId,
                    contractId: this.taskNoteModel.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                    prebuyInvoiceId: this.taskNoteModel.prebuyInvoiceId,
                    contractId: this.taskNoteModel.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.taskNoteModel.preInvoiceId,
                        contractId: this.taskNoteModel.contractId,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                        contractId: this.taskNoteModel.contractId,
                        projectId: this.taskNoteModel.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                        prebuyInvoiceId: this.taskNoteModel.prebuyInvoiceId,
                        contractId: this.taskNoteModel.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },




            onChangeWorkGroup() {
                this.taskNoteModel.mentionUserIdsList = [];
                this.taskNoteModel.userId = null;
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: this.taskNoteModel.workGroupId
                });
                this.$store.dispatch("GetLocalUserListForMention", {
                    workGroupId: this.taskNoteModel.workGroupId
                });
            },
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }

            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {});
                this.$http.get("Account/GetLogginedUserID")
                    .then(data => {
                        this.taskNoteModel.userId = data.data;
                        this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                            .then(data => {
                                if (data.data.expired)
                                    document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "none");
                                else {

                                    setTimeout(function () {
                                        document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "block");
                                    }, 1000)
                                }
                            });
                    });
            },
            CreateTaskNote() {

                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("CreateTaskNote", this.taskNoteModel);
                    this.modified = false;
                }

            },

            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        this.taskNoteModel.createDateTime = data.data.replace("_", " ");
                    });

            },
            SetAttList(e) {
                console.log(e);
                this.taskNoteModel.attList = e;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        mounted() {
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    this.taskNoteModel.description = this.taskNoteModel.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }

            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        validations: {
            taskNoteModel: {
                title: {
                    required,
                },
                userId: {
                    required,
                }
            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }
    };
</script>
